/** Types */

/** REST action types */
export const GET_CHATS = 'GET_CHATS';
export const GET_CHATS_SUCCESS = 'GET_CHATS_SUCCESS';
export const GET_CHAT_USERS = 'GET_CHAT_USERS';
export const GET_CHAT_USERS_SUCCESS = 'GET_CHAT_USERS_SUCCESS';
export const CREATE_CHAT = 'CREATE_CHAT';
export const CREATE_CHAT_SUCCESS = 'CREATE_CHAT_SUCCESS';
export const DELETE_CHAT = 'DELETE_CHAT';
export const REMOVE_CHAT_MEMBER = 'REMOVE_CHAT_MEMBER';
export const REMOVE_CHAT_MEMBER_SUCCESS = 'REMOVE_CHAT_MEMBER_SUCCESS';
export const ADD_CHAT_MEMBERS = 'ADD_CHAT_MEMBERS';
export const ADD_CHAT_MEMBERS_SUCCESS = 'ADD_CHAT_MEMBERS_SUCCESS';
export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const EDIT_MESSAGE = 'EDIT_MESSAGE';
export const DELETE_MESSAGE = 'DELETE_MESSAGE';
export const SEARCH_MESSAGES = 'SEARCH_MESSAGES';
export const SEARCH_MESSAGES_SUCCESS = 'SEARCH_MESSAGES_SUCCESS';
export const UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT';
export const MARK_CHAT_READ = 'MARK_CHAT_READ';
export const MARK_MESSAGE_READ = 'MARK_MESSAGE_READ';
export const MUTE_CHAT = 'MUTE_CHAT';
export const MUTE_CHAT_SUCCESS = 'MUTE_CHAT_SUCCESS';

/** Socket-only types */
export const CHAT_CREATED = 'CHAT_CREATED';
export const CHAT_DELETED_EVENT = 'CHAT_DELETED_EVENT';
export const CHAT_MEMBER_REMOVED_EVENT = 'CHAT_MEMBER_REMOVED_EVENT';
export const CHAT_MEMBERS_ADDED_EVENT = 'CHAT_MEMBERS_ADDED_EVENT';
export const CHAT_RECEIVE_MESSAGE = 'CHAT_RECEIVE_MESSAGE';
export const CHAT_UNREAD_UPDATE = 'CHAT_UNREAD_UPDATE';
export const CHAT_MESSAGE_EDITED = 'CHAT_MESSAGE_EDITED';
export const CHAT_MESSAGE_DELETED = 'CHAT_MESSAGE_DELETED';
export const CHAT_MESSAGE_READ = 'CHAT_MESSAGE_READ';
export const CHAT_SET_TYPING = 'CHAT_SET_TYPING';
export const CHAT_CLEAR_TYPING = 'CHAT_CLEAR_TYPING';

/** UI state types */
export const SET_ACTIVE_CHAT = 'SET_ACTIVE_CHAT';
export const CLEAR_ACTIVE_CHAT = 'CLEAR_ACTIVE_CHAT';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const CLEAR_CHAT_USERS = 'CLEAR_CHAT_USERS';
